export default __webpack_public_path__ + "static/media/eye-closed.de48758f.svg";